import ng from 'angular';

export class MotivoRecusaModalController implements ng.IController {

    static $inject = [
        '$uibModalInstance'
    ];

    public motivo: string = '';

    constructor(
        private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService
    ) {}

    public confirmar(): void {
        if (!this.motivo || !this.motivo.trim()) {
            return;
        }

        this.$uibModalInstance.close(this.motivo.trim());
    }

    public cancelar(): void {
        this.$uibModalInstance.dismiss('cancelar');
    }

    public motivoValido(): boolean {
        return !!this.motivo && !!this.motivo.trim();
    }
}
